import React, { Component } from 'react';

type Props = {

    /**
     * ID of the toggle.
     */
    id: string,

    /**
     * CSS class name.
     */
    className: string,

    /**
     * Indicates whether the switch is disabled or not.
     */
    disabled: boolean,

    /**
     * Handler called when the value changes, passing the new boolean value.
     */
    onValueChange: ?Function,

    /**
     * Standard onChange handler, passing the event object.
     */
    onChange: ?Function,

    /**
     * The current value.
     */
    value: boolean
};

/**
 * Renders a boolean input.
 */
export default class Switch extends Component<Props> {
    /**
     * Initializes a new {@code Switch} instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props: Props) {
        super(props);

        this._onChange = this._onChange.bind(this);
    }

    _onChange: (Object) => void;

    /**
     * Change handler for the checkbox.
     *
     * @param {Object} event - The HTML change event.
     * @private
     * @returns {void}
     */
    _onChange(event) {
        const { onValueChange, onChange } = this.props;

        if (onValueChange) {
            onValueChange(event.target.checked);
        }

        if (onChange) {
            onChange(event);
        }
    }

    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const {
            className,
            disabled,
            value,
            id
        } = this.props;

        return (
            <div className = { `meethour-switch-container ${className || ''}` }>
                <label className = { `meethour-switch ${disabled ? 'disabled' : ''}` }>
                    <input
                        checked = { value }
                        disabled = { disabled }
                        id = { id }
                        onChange = { this._onChange }
                        type = 'checkbox' />
                    <span className = 'meethour-switch-slider' />
                </label>
            </div>
        );
    }
}
